import styled from "styled-components";

export const MonthSettlementDailyTableHeader = styled.div`
  display: flex;
  justify-content: space-between;

  > .wrapper {
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer;
  }
`;

export const MonthSettlementDailyTableCheckBox = styled.div<{
  selected: boolean;
}>`
  border: 2px solid ${({ selected }) => (selected ? "#7F25FB" : "#d9d9d9")};
  background: #ffffff;
  width: 27px;
  height: 27px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const MonthSettlementDailyTableWrapper = styled.div`
  border-top: 1.53px solid #d9d9d9;
  margin-top: 12px;
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .item {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    flex: 1;
  }

  .date {
    width: 90px;
    flex: none;
  }

  .button {
    min-width: 76px;
    max-width: 172px;
    flex: none;
  }

  .wrapper {
    width: 172px;
    flex: none;
  }
`;

export const MonthSettlementDailyTableHeaderItems = styled.div`
  display: flex;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
`;

export const MonthSettlementDailyTableBodyWrapper = styled.div`
  height: 560px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 30px;
  box-sizing: border-box;
  scrollbar-width: none;
`;

export const MonthSettlementDailyTableBody = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  background: #ecf0f3;
  height: 50px;
  border-radius: 10.64px;
  padding: 0 30px;
  box-sizing: border-box;

  > .button {
    display: flex;
    justify-content: flex-end;
    gap: 20px;

    > span {
      width: 76px;
      height: 30px;
      border-radius: 6px;
      background: #bebebe;
      font-weight: 700;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      cursor: pointer;

      &.red {
        background: #d91818;
      }
    }
  }
`;
